import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SellNow } from './sell-now.actions';

export interface SellNowStateModel {
    form: any;
    intro: boolean; // if the user already had the intro presented
}

@State<SellNowStateModel>({
    name: 'sellNow',
    defaults: {
        form: null,
        intro: false
    }
})
@Injectable()
export class SellNowState {
    @Selector()
    static sellForm(state: SellNowStateModel) {
        return state.form;
    }

    @Selector()
    static presentIntro(state: SellNowStateModel) {
        return state.intro;
    }

    @Action(SellNow.UpdateForm)
    updateForm(ctx: StateContext<SellNowStateModel>, { payload }: SellNow.UpdateForm) {
        ctx.patchState({
            form: payload
        });
    }

    @Action(SellNow.UpdateIntro)
    updateIntro(ctx: StateContext<SellNowStateModel>, { payload }: SellNow.UpdateIntro) {
        ctx.patchState({
            intro: payload
        });
    }
}
